import Startup from "./utils/Startup";

const App = () => {
  return (
    <div className="App">
      <Startup />
    </div>
  );
};

export default App;
